import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import SuccessStory from "../home/_components/successStory";
import AllPrograms from "./_components/all-programs";
import Hero from "./_components/hero";

export default function AllCourses() {
  return (
    <WebLayout>
      <Hero />
      <AllPrograms />
      <SuccessStory />
      <Platform />
      <Footer isPlatform={true} />
    </WebLayout>
  );
}
